import React, { useState } from 'react';
import { ArrowRightCircleIcon, ChevronDownIcon, MagnifyingGlassCircleIcon } from '@heroicons/react/24/solid';
import { Swipeable } from '../../../components/⚛️atoms/Swipeable';
import {useTranslation} from "react-i18next";

export const MobilePageSearch = ({ setPageQuery }) => {
  const [showMobilePageSearch, setShowMobilePageSearch] = useState(false);
  const { t } = useTranslation();
  return (
    <Swipeable onSwipeUp={() => setShowMobilePageSearch(false)}>
      <div className="pointer-events-none fixed top-0 left-0 h-screen w-screen">
        <button className="relative h-[9dvh] w-full" onClick={() => setShowMobilePageSearch(!showMobilePageSearch)}>
          <span className="pointer-events-auto absolute top-4.5 right-20 flex w-min items-center border-r-1 border-gray-200 pr-3 text-left text-xl">
            {t('Page Search')}
            <ChevronDownIcon className="size-8" />
          </span>
        </button>
        <div
          className={`fixed z-50 ${showMobilePageSearch ? 'h-screen w-screen' : 'h-0 w-0'} pointer-events-auto backdrop-blur-sm`}
          onClick={() => setShowMobilePageSearch(false)}
        ></div>
        <div
          className={`text-pddarkblue fixed left-0 z-90 ml-[1dvw] h-13/100 w-[98dvw] gap-3 rounded-b-2xl border-1 border-gray-200 bg-white px-3 py-1 text-xs font-bold shadow-2xl transition-all duration-300 ${showMobilePageSearch ? 'top-0' : '-top-50'} pointer-events-auto flex flex-col items-center justify-center`}
          onClick={(e) => e.stopPropagation()}
        >
          <span>{t('Page Number Search')}</span>
          <div className="flex items-center gap-5">
            <label className="relative flex w-55 items-center gap-2 whitespace-nowrap">
              <MagnifyingGlassCircleIcon className="text-pddarkblue/70 absolute top-1/2 left-1 size-8 -translate-y-1/2" />
              <input
                className="focus:outline-pdteal block w-full rounded-md bg-white px-6 py-3 pl-10 text-2xl text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 sm:text-2xl/6"
                placeholder={t('Search...')}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    setPageQuery(e.target.value);
                    setShowMobilePageSearch(false);
                  }
                }}
              />
            </label>
            <button
              onClick={(e) => {
                setPageQuery(e.target.closest('div').querySelector('input').value);
                setShowMobilePageSearch(false);
              }}
            >
              <ArrowRightCircleIcon className="text-pdteal size-12 font-bold" />
            </button>
          </div>
        </div>
      </div>
    </Swipeable>
  );
};
